import React, { useContext, useEffect, useState } from "react";
import { Form, Formik } from "formik";
import List, { STATE } from "../../List/index.jsx";
import SecondaryPagination from "../../SecondaryPagination/SecondaryPagination.jsx";
import { TextBox, Button, Overlay } from "../../index.js";

import { ReactComponent as TrashSvg } from "../../../assets/icons/trash-2.svg";
import { ReactComponent as Pencil } from "../../../assets/icons/pencil.svg";
import { ReactComponent as WarningSvg } from "../../../assets/icons/warning.svg";

import { format } from "date-fns";
import View from "./View.jsx";
import { langComponent, PAGE_STATE } from "../../../constants/index.jsx";
import AppContext from "../../../AppContext.jsx";
import Switch from "react-switch";
import { toast } from "react-toastify";
import useFAQs from "../../../hooks/useFAQ.js";

const columns = [
  {
    display: "Category",
    key: "category",
    textAlign: "left",
    width: 100,
    // maxWidth: 150,
  },
  {
    display: "Page",
    key: "subCategory",
    textAlign: "left",
    width: 100,
    // maxWidth: 150,
  },
  {
    display: "Language",
    key: "language",
    textAlign: "left",
    width: 100,
    // maxWidth: 150,
  },
  {
    display: "Created on",
    key: "joined",
    textAlign: "left",
    width: 50,
    maxWidth: 80,
  },
  {
    display: "Status",
    key: "status",
    textAlign: "left",
    width: 80,
    maxWidth: 100,
  },
  {
    display: "",
    key: "actions",
    textAlign: "left",
    width: 32,
    maxWidth: 32,
  },
];
const mappingLanguage = {
  en: "English",
  th: "Thai",
  cn: "Chinese",
};

const Faqs = () => {
  const [dataState, setDataState] = useState(STATE.LOADING);
  const [blogs, setBlogs] = useState(undefined);
  const [metadata, setMetadata] = useState(undefined);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({
    deleted: false,
  });
  const [enableActions, setEnableActions] = useState(false);
  const [selections, setSelections] = useState([]);
  const [toggleAdd, setToggleAdd] = useState(false);
  const [toggleDelete, setToggleDelete] = useState(false);

  // * Toggles
  const [toggleView, setToggleView] = useState(false);
  const [selected, setSelected] = useState(undefined);
  const { queryFAQ, deleteFAQ, patchFAQ } = useFAQs();
  const { faqs, lang } = useContext(AppContext);
  const FAQCategory = faqs.category;
  const FAQSubCategory = faqs.subCategory;

  useEffect(() => {
    changeDefaultFilter();
    return () => {};
  }, []);

  const changeDefaultFilter = () => {
    setFilter({
      deleted: false,
    });
  };
  const handleChangeStatus = async (_id, status) => {
    try {
      await patchBlog(_id, {
        status,
      });
      await fetchData();
      toast.success("Update Status Complete");

      setDataState(PAGE_STATE.IDLE);
    } catch (error) {
      console.error(error.message);
      toast.error("Unable to Change Status");

      setDataState(PAGE_STATE.ERROR);
    }
  };

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  useEffect(() => {
    fetchData();
  }, [filter, limit, page]);

  useEffect(() => {
    setEnableActions(selections.length > 0);
  }, [selections]);

  // * Fetch data
  const fetchData = async () => {
    const { data, _metadata } = await queryFAQ(filter, page, limit, {
      category: 1,
      subCategory: 1,
      status: 1,
      language: 1,
      createdOn: 1,
    });
    if (data.length == 0) {
      setPage(1);
    }

    let _faqs = data.map(
      ({ _id, category, subCategory, status, createdOn, language }) => {
        const _joined = createdOn
          ? format(new Date(createdOn), "dd/MM/yyyy")
          : "-";
        // const truncateText = truncateTextAfterWords(desc, 30);
        const faqCategory = FAQCategory.find((w) => w.value === category);

        const faqSubCategory = FAQSubCategory.find(
          (w) => w.value === subCategory
        );
        return {
          no: 1,
          category: faqCategory ? faqCategory.name : "",
          subCategory: faqSubCategory ? faqSubCategory.name : "",
          joined: _joined,
          language: mappingLanguage[language],
          // content,
          status: (
            <div className="admin-bp-item-status">
              <Switch
                checked={status == 1 ? true : false}
                onChange={(value) => {
                  handleChangeStatus(_id, value);
                }}
                onColor="#013565"
                onHandleColor="#FFF"
                handleDiameter={15}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={25}
                width={48}
                className="react-switch"
                id={`blog-switch-${_id}`}
              />
            </div>
          ),
          actions: (
            <div className="admin-bp-item-actions">
              <div
                className="admin-bp-item-actions-action"
                onClick={() => handleView(_id)}
              >
                <Pencil />
              </div>
              <div
                className="admin-bp-item-actions-action"
                onClick={() => handleToggleDelete(_id)}
              >
                <TrashSvg />
              </div>
            </div>
          ),
        };
      }
    );

    setBlogs(_faqs);
    setMetadata(_metadata);
    setDataState(STATE.IDLE);
  };

  const handleOnPageChange = (page) => setPage(page);

  const handleOnLimitChange = (limit) => {
    setLimit(limit);
  };

  // const handleSearchChange = async (value) => {
  //   if (!value) {
  //     setFilter({
  //       deleted: false,
  //     });
  //     return;
  //   }

  //   setFilter({
  //     $or: [
  //       {
  //         name: { $regex: value },
  //       },
  //     ],
  //     $and: [
  //       {
  //         deleted: false,
  //       },
  //     ],
  //   });
  //   // await fetchData();
  // };

  const handleAddBlog = () => {
    // * handleAddUser
    setSelected(undefined);
    setToggleView(true);
  };

  const handleView = (id) => {
    setSelected(id);
    setToggleView(true);
  };

  const handleViewClose = () => {
    setSelected(undefined);
    setToggleView(false);
    setToggleDelete(false);
  };

  const handleViewSuccess = () => {
    setSelected(undefined);
    setToggleView(false);
    fetchData();
  };
  const modalDelete = () => {
    return (
      <>
        <Overlay
          onClose={() => {
            handleViewClose();
          }}
          style={{
            alignItems: "flex-start",
          }}
        >
          <div className="admin-bp-delete">
            <WarningSvg />
            <p>Delete FAQ</p>
            <div className="admin-bp-delete__action">
              <Button
                variant={"secondary"}
                label={"Cancel"}
                onClick={handleViewClose}
              />
              <Button
                label={"Confirm"}
                onClick={() => handleDelete(selected)}
              />
            </div>
          </div>
        </Overlay>
      </>
    );
  };
  const handleShowMore = () => {
    setLimit(limit + 5);
  };
  const handleToggleDelete = (id) => {
    if (toggleView) {
      setSelected(undefined);
    }

    setToggleDelete(!toggleDelete);
    setSelected(id);
  };
  const handleDelete = async (id) => {
    try {
      await deleteFAQ(id);
      setToggleDelete(!toggleDelete);
      setSelected(undefined);
      await fetchData();
      toast.success("Delete FAQ Complete");

      setDataState(PAGE_STATE.IDLE);
    } catch (error) {
      console.error(error.message);
      toast.error("Unable to Delete FAQ");

      setDataState(PAGE_STATE.ERROR);
    }
  };

  return (
    <>
      <div className="admin-bp">
        <div className="admin-bp-header">
          {/* <SearchBox placeholder="Faq Category" onChange={handleSearchChange} /> */}
          <div className="admin-bp-header-actions">
            <div className={`admin-bp-header-actions-action`}>
              <Button label={"Create new FAQ"} onClick={handleAddBlog}></Button>
            </div>
          </div>
        </div>
        <List
          className="admin-bp-lists-item-name"
          contentState={dataState}
          columns={columns}
          dataSource={blogs}
          onRecordClick={(e) => handleSelected(e)}
        >
          <div className="admin-bp-lists-footer__pagination">
            <SecondaryPagination
              limits={[10, 50]}
              defaultPage={metadata?.currentPage || 1}
              defaultLimit={limit}
              pages={metadata?.totalPages || 1}
              onPageChange={handleOnPageChange}
              onLimitChange={handleOnLimitChange}
            />
          </div>
          <div className="admin-bp-lists-footer__button">
            {metadata?.totalPages > 1 ? (
              <Button label={"Show More"} onClick={handleShowMore} />
            ) : (
              <></>
            )}
          </div>
        </List>
      </div>
      {(toggleAdd || toggleView) && (
        <View
          section={2}
          editing={toggleView && selected}
          onClose={handleViewClose}
          onSuccess={handleViewSuccess}
        />
      )}
      {toggleDelete && modalDelete()}
    </>
  );
};

Faqs.propTypes = {};

export default Faqs;
